/** 詳細設定の画質 */
export const DETAIL_QUALITY = "DETAIL_QUALITY";